import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Padding } from '../UI/index'
import { TextAreaInput, TextInput, TextEditor } from '../UI'
import setByPath from 'lodash/set'
import getByPath from 'lodash/get'
import { NotificationManager } from 'react-notifications'

import _ from 'lodash'

import config from './../../config'
import ImageUpload from '../ImageLoader/ImageLoader'

import ImgBankPhotoSelectionModal from '../ImgBankPhotoSelection/ImgBankPhotoSelectionModal'

export default class NotesComponent extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    initialData: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    user: PropTypes.object
  }
  constructor(props) {
    super(props)

    this.state = {
      form: _.cloneDeep(this.props.initialData) || {
        title: '',
        description: '',
        content: ''
      },
      photos: []
    }
  }

  componentWillReceiveProps = props => {
    if (props.initialData) {
      // this.setState({
      //   form: props.initialData
      // });
      // this.onFormFieldChange('content', content);
    }
  }

  onFormFieldChange(id, value, callback) {
    const form = this.state.form
    const newForm = setByPath(form, id, value)

    this.setState(
      {
        form: newForm
      },
      () => {
        if (callback) {
          callback()
        }
      }
    )
  }

  handleChange(e) {
    let photo = e[0]

    let reader = new FileReader()
    reader.onload = function(e) {
      photo.src = e.target.result

      this.onImageUpload(photo)
    }.bind(this)

    reader.readAsDataURL(e[0])
  }

  removePhoto = e => {
    this.onFormFieldChange('defaultPhoto', null)
  }

  closeModal = () => {
    const imgModal = {}
    imgModal['imgModal'] = false
    this.setState(imgModal, () => {})
  }

  async onImageUpload(thefile) {
    let data = new FormData()
    data.append('data', thefile)

    let res
    let file
    try {
      res = await fetch(config.fileAPI, {
        method: 'POST',
        body: data
      })
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }

    try {
      file = await res.json()
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }

    this.onFormFieldChange('defaultPhoto', file)
  }

  render() {
    const { t } = this.props

    let photo = this.state.form.defaultPhoto ? this.state.form.defaultPhoto : {}

    return (
      <Padding size="24px">
        <h1>{t('page_title')}</h1>
        <hr />
        <div className="form-horizontal create-note__form-container">
          <div className="form-group">
            <TextInput
              label={t('title_label')}
              labelClass="create-note__form-label col-md-3 control-label"
              inputWrapperClass="col-md-9"
              id="title"
              extraClass="form-control create-note__form-input"
              placeholder={t('title_placeholder')}
              initialValue={this.state.form.title}
              onChangeExternal={(id, value) => this.onFormFieldChange(id, value)}
            />
            <div className="form-horizontal create-note__form-container">
              <h2 className="create-note__form-group-label">{t('description_label')}</h2>
              <div className="create-note__example-container">
                <i className="icon-flag create-note__example-icon" />
                <span className="create-note__example-text">{t('description_example')}</span>
              </div>

              <TextAreaInput
                id="description"
                initialValue={this.state.form.description}
                maxChars={100}
                onChangeExternal={(id, props) => this.onFormFieldChange(id, props)}
                placeholder={t('description_placeholder')}
              />
            </div>
            <TextEditor
              id="editor"
              value={this.state.form.content}
              onChange={(content, delta, source, editor) => {
                this.onFormFieldChange('content', content)
              }}
            />          

            <div className="steps-screen">
              <div className="steps-screen__form-input-area photos__form">
                <div className="photo-upload">
                  <div className={photo.url || photo.src ? 'hidden' : 'photo-wrapper'}>
                    <div
                      className="missing-photo"
                      onClick={e => {
                        let imgModal = {}
                        imgModal['imgModal'] = true
                        this.setState(imgModal, () => {
                          console.log(this.state)
                        })
                      }}
                    >
                      <i className="icon-plus" />
                    </div>

                    <ImgBankPhotoSelectionModal
                      id={'file'}
                      user={this.props.user}
                      isOpen={this.state['imgModal']}
                      onClose={this.closeModal}
                      onFileChange={e => this.handleChange(e)}
                      t={t}
                    />
                  </div>

                  <div className={photo.s3Url || photo.src ? 'photo-upload__image-wrapper' : 'hidden'}>
                    <img src={photo.s3Url || photo.src} className={photo.s3Url || photo.src ? 'photo-upload__image' : 'hidden'} />
                    <button className="photo-upload__remove-btn" onClick={e => this.removePhoto(e)}>
                      <i className="icon-plus" />
                      {t('main:remove')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button className="btn create-note__submit-btn" onClick={() => this.props.onSubmit(this.state.form)}>
            {t('save_and_exit')}
          </button>
        </div>
      </Padding>
    )
  }
}



// WEBPACK FOOTER //
// src/components/Notes/NotesComponent.js